import loggerFactory from '../../logger';
const log = loggerFactory.get('repository:storage:item');

function StorageItem(object) {
    try {
        this.data = JSON.stringify(object);
    } catch (e) {
        log.error('could not stringify object', object);
        throw e;
    }
    this.lastTouched = Date.now();
}

StorageItem.prototype.touch = function () {
    this.lastTouched = Date.now();
};

StorageItem.prototype.getSize = function () {
    return this.data.length * 2;
};

StorageItem.prototype.getObject = function () {
    return JSON.parse(this.data);
};

export default StorageItem;
